import React from 'react';
import { useGetColumnDisplayName } from 'apps/sigma2-ui/src/explore-section/hooks/useGetColumnDisplayName';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

interface StackedBarChartPlaceholderProps {
  metricName: string;
  chartHeight: number;
}

export const StackedBarChartPlaceholder: React.FC<
  StackedBarChartPlaceholderProps
> = ({ metricName, chartHeight }) => {
  const { getColumnDisplayName } = useGetColumnDisplayName();
  const language = useLanguage();

  return (
    <div key={metricName} className="w-full">
      {/* Metric title */}
      <h3 className="text-base font-semibold text-gray-800 mb-3 px-2">
        {getColumnDisplayName(metricName)}
      </h3>

      <div className="w-full bg-white" style={{ height: `${chartHeight}px` }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="568"
          height="120"
          role="img"
          focusable="false"
        >
          <rect width="568" height="120" fill="#ffffff"></rect>
          <g transform="translate(20,10)">
            <g>
              <line
                opacity="1"
                x1="0"
                x2="528"
                y1="30"
                y2="30"
                stroke="#dddddd"
                strokeWidth="1"
              ></line>
            </g>
            <g transform="translate(0,60)">
              <line
                x1="0"
                x2="528"
                y1="0"
                y2="0"
                style={{ stroke: 'rgb(184, 186, 188)', strokeWidth: '1' }}
              ></line>
            </g>
            <g transform="translate(0,0)">
              <g transform="translate(0,30)" style={{ opacity: 1 }}>
                <line
                  x1="0"
                  x2="0"
                  y1="0"
                  y2="0"
                  style={{ stroke: 'rgb(184, 186, 188)', strokeWidth: '1' }}
                ></line>
                <text
                  dominantBaseline="central"
                  textAnchor="end"
                  transform="translate(0,0) rotate(0)"
                  style={{
                    fontFamily: 'Karla, sans-serif',
                    fontSize: '13px',
                    fill: 'rgb(51, 51, 51)',
                  }}
                ></text>
              </g>
              <line
                x1="0"
                x2="0"
                y1="0"
                y2="60"
                style={{ stroke: 'rgb(184, 186, 188)', strokeWidth: '1' }}
              ></line>
              <text
                transform="translate(0, 30) rotate(-90)"
                textAnchor="middle"
                style={{
                  dominantBaseline: 'central',
                  fontFamily: 'Karla, sans-serif',
                  fontSize: '12px',
                  fill: 'rgb(51, 51, 51)',
                  outlineWidth: '0px',
                  outlineColor: 'transparent',
                }}
              ></text>
            </g>
            <g transform="translate(0, 12)">
              <rect
                width="200"
                height="36"
                rx="3"
                ry="3"
                fill="#6b7280"
                strokeWidth="0"
                stroke="rgb(112, 80, 237)"
              ></rect>
            </g>
            <g transform="translate(200, 12)">
              <rect
                width="100"
                height="36"
                rx="3"
                ry="3"
                fill="#9ca3af"
                strokeWidth="0"
                stroke="rgb(237, 109, 80)"
              ></rect>
            </g>
            <g transform="translate(300, 12)">
              <rect
                width="70"
                height="36"
                rx="3"
                ry="3"
                fill="#d1d5db"
                strokeWidth="0"
                stroke="rgb(120, 210, 203)"
              ></rect>
            </g>
            <g transform="translate(370, 12)">
              <rect
                width="70"
                height="36"
                fill="#e5e7eb"
                strokeWidth="0"
                stroke="rgb(231, 174, 56)"
              ></rect>
            </g>
            <g transform="translate(440, 12)">
              <rect
                width="90"
                height="36"
                rx="3"
                ry="3"
                fill="#f3f4f6"
                strokeWidth="0"
                stroke="rgb(166, 82, 102)"
              ></rect>
            </g>
          </g>
          <text
            transform="translate(20,90) rotate(0)"
            style={{
              fontFamily: 'Karla, sans-serif',
              fontSize: '13px',
              fill: 'rgb(51, 51, 51)',
            }}
          >
            {language.cannotDisplayCountsForMetric()}
          </text>
        </svg>
      </div>
    </div>
  );
};
